export const PURCHASE_ORDER_ROUTES = {
  list: '/staff/purchase-orders',
  new: '/staff/purchase-orders/new',
  detail: '/staff/purchase-orders/:id',
} as const;
